<template>
  <section v-if="$role.restricAccess($route.name, 'view')">
    <breadcrumb-template
      :headtitle="$route.meta.title"
      :breadcrumbcurrent="$route.meta.title"
    ></breadcrumb-template>
    <v-card class="card-outline force-remove-box">
      <v-card-text class="force-custom-bg">
        <v-container fluid>
          <v-row dense class="d-flex justify-end mt-n2">
            <v-col cols="12" lg="2" class="span-label">
              <span class="control-label">Dates</span>
              <v-dialog
                ref="dialog"
                v-model="filter_datedialog"
                :return-value.sync="filter.daterange"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    class="regular-field"
                    dense
                    v-model="filter.daterange"
                    label="Dates"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker v-model="filter.daterange" scrollable range>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="filter_datedialog = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.dialog.save(filter.daterange)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-dialog>
            </v-col>

            <v-col cols="12" lg="3">
              <v-text-field
                clearable
                dense
                class="regular-field"
                v-model="dt_searchQuery"
                label="Search any keyword"
                hide-details
              ></v-text-field>
            </v-col>

            <v-col cols="12" lg="2" class="mt-7" style="padding-top:5px;">
              <v-btn
                color="green_button"
                class="float-right btn-block"
                @click="getDataFromApi()"
                >Search</v-btn
              >
            </v-col>

            <v-col
              cols="12"
              lg="3"
              class="mt-7"
              style="padding-top:5px;"
              v-if="$role.restricAccess($route.name, 'add')"
            >
              <v-btn
                color="info"
                class="float-right btn-block"
                @click="modalForm"
                >Add block number</v-btn
              >
            </v-col>

            <v-col cols="12" class="mt-2">
              <v-data-table
                class="custom-header-color table-bordered table-striped"
                :headers="dt_headers"
                :items="dt_resultlist"
                item-key="id"
                :loading="dt_loading"
                :options.sync="dt_options"
                :server-items-length="dt_totalResult"
              >
                <template v-slot:[`item.periodfrom`]="{ item }">{{
                  item.periodfrom | setDate
                }}</template>
                <template v-slot:[`item.periodto`]="{ item }">{{
                  item.periodto | setDate
                }}</template>
                <template v-slot:[`item.dateto`]="{ item }">{{
                  item.dateto | setDate
                }}</template>

                <template
                  v-slot:[`item.actions`]="{ item }"
                  v-if="$role.restricAccess($route.name, 'edit')"
                >
                  <v-btn color="info" block dark small @click="findData(item)">
                    Edit
                  </v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <section>
      <v-dialog v-model="dialogForm" width="750px" scrollable persistent>
        <v-card class="card-outline custom-color-dialog">
          <v-card-title class="headline headline_bg">
            <span v-if="modalUpdate">Update block number</span>
            <span v-else>Create block number</span>
          </v-card-title>

          <v-card-text>
            <v-row dense class="pt-6">
              <v-col cols="12" lg="6" class="span-label">
                <span class="control-label">Number combination</span>
                <v-text-field
                  dense
                  class="regular-field"
                  v-model="form.numbercombination"
                  label="Number combination"
                  :error-messages="formerror.numbercombination"
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="6" class="span-label">
                <span class="control-label">Draw</span>
                <v-select
                  :items="draw_list"
                  item-text="name"
                  item-value="id"
                  dense
                  class="regular-field"
                  v-model="form.draw_id"
                  label="Draw"
                  :error-messages="formerror.draw_id"
                ></v-select>
              </v-col>
              <v-col cols="12" lg="6" class="span-label">
                <span class="control-label">Date from</span>
                <v-text-field
                  dense
                  class="regular-field"
                  v-model="form.datefrom"
                  label="Date from"
                  :error-messages="formerror.datefrom"
                  type="date"
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="6" class="span-label">
                <span class="control-label">Date to</span>
                <v-text-field
                  dense
                  class="regular-field"
                  v-model="form.dateto"
                  label="Date to"
                  :error-messages="formerror.dateto"
                  type="date"
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="12" class="span-label">
                <span class="control-label">Status</span>
                <v-select
                  :items="['Active', 'Inactive']"
                  dense
                  class="regular-field"
                  v-model="form.status"
                  label="Status"
                  :error-messages="formerror.status"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-checkbox
                  dense
                  v-model="form.is_wholenumber"
                  label="Straight"
                ></v-checkbox>
              </v-col>
              <v-col cols="12">
                <v-checkbox
                  dense
                  v-model="form.istoRamble"
                  label="Any order"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions class="actionButtons">
            <v-row no-gutters>
              <v-col cols="12" lg="12">
                <v-btn color="red_button" @click="dialogForm = false"
                  >Back</v-btn
                >
                <span v-if="$role.restricAccess($route.name, 'edit')"
                  ><v-btn
                    color="green_button"
                    class="float-right"
                    @click="updateData"
                    v-if="modalUpdate"
                    :loading="isLoadingBtn"
                    >Update</v-btn
                  ></span
                >
                <v-btn
                  color="green_button"
                  class="float-right"
                  @click="newData"
                  v-if="!modalUpdate"
                  :loading="isLoadingBtn"
                  >Save</v-btn
                >
                <span v-if="$role.restricAccess($route.name, 'delete')"
                  ><v-btn
                    color="delete_button"
                    class="float-right mr-3"
                    dark
                    :loading="isLoadingBtnDelete"
                    @click="deleteData(form.id)"
                    v-if="modalUpdate"
                    >Delete</v-btn
                  ></span
                >
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </section>

    <confirm-dialog
      ref="confirm"
      class="custom-confirm-dialog"
    ></confirm-dialog>
  </section>
</template>

<script>
export default {
  data() {
    return {
      schedules: [
        { name: "Sunday" },
        { name: "Monday" },
        { name: "Tuesday" },
        { name: "Wednesday" },
        { name: "Thursday" },
        { name: "Friday" },
        { name: "Saturday" },
      ],
      dialogForm: false,
      isLoadingBtn: false,
      isLoadingBtnDelete: false,
      formerror: {},
      modalUpdate: false,
      filter_datedialog: null,
      dt_headers: [
        {
          text: "ID",
          value: "id",
          name: "id",
          sortable: true,
          searchable: false,
          align: " d-none",
        },
        {
          text: "Combination",
          value: "numbercombination",
          name: "numbercombination",
          sortable: false,
          searchable: false,
        },
        {
          text: "Draw",
          value: "name",
          name: "name",
          sortable: false,
          searchable: false,
        },
        {
          text: "Frequency",
          value: "frequency",
          name: "frequency",
          sortable: false,
          searchable: false,
        },
        {
          text: "Period from",
          value: "periodfrom",
          name: "periodfrom",
          sortable: false,
          searchable: false,
        },
        {
          text: "Period to",
          value: "periodto",
          name: "periodto",
          sortable: false,
          searchable: false,
        },
        {
          text: "Date to block",
          value: "dateto",
          name: "dateto",
          sortable: false,
          searchable: false,
        },
        // {
        //   text: "Status",
        //   value: "status",
        //   name: "status",
        //   sortable: false,
        //   searchable: false,
        // },
        // {
        //   text: "Actions",
        //   value: "actions",
        //   sortable: false,
        //   searchable: false,
        //   width: "10%",
        // },
      ],
      dt_options: {},
      dt_columns: {},
      dt_totalResult: 0,
      dt_searchInput: "",
      dt_searchQuery: "",
      dt_resultlist: [],
      dt_loading: true,
      dt_itemsPerPage: 50,
      dt_reload: "",
      dt_total_winnerprize: "",
      filter: {
        datefrom: null,
        dateto: null,
        playertype: null,
        daterange: null,
      },
      form: new this.$Form({
        id: "",
        numbercombination: "",
        draw_id: "",
        dateto: "",
        datefrom: "",
        is_wholenumber: "",
        istoRamble: "",
        status: "",
      }),
      draw_list: null,
    };
  },
  methods: {
    schedule_draw_format(val) {
      // let data = [];
      // val = JSON.parse(val);
      // val.forEach(element => {
      //     data.push(element.name);
      // });
      // return data.join(', ');
    },
    modalForm() {
      this.modalUpdate = false;
      this.form.reset();
      this.dialogForm = true;
    },
    copyClipboard(data) {
      data = data.split(" / ");
    },
    async newData() {
      this.isLoadingBtn = true;
      this.form
        .post(this.$_CONFIG.api("API_FEATURED_NUMBER"))
        .then(({ data }) => {
          this.isLoadingBtn = false;
          this.getDataFromApi();
          this.dialogForm = false;
          // this.$Swal.fire(
          //   "Success!",
          //   "Record has been successfully added.",
          //   "success"
          // );
          this.$toast.fire({
            icon: "success",
            title: "Record has been successfully added.",
          });
        })
        .catch((error) => {
          this.isLoadingBtn = false;
          this.formerror = error.response.data.errors;
          this.$toast.fire({ icon: "error", title: "Something went wrong!" });
        });
    },
    async findData(data) {
      this.formerror = {};
      this.form.reset();
      this.form.fill(data);
      console.log(this.form);
      this.modalUpdate = true;
      this.dialogForm = true;
    },
    async updateData() {
      this.isLoadingBtn = true;
      this.form
        .put(this.$_CONFIG.api("API_FEATURED_NUMBER") + "/" + this.form.id)
        .then(() => {
          this.isLoadingBtn = false;
          this.dialogForm = false;
          this.getDataFromApi();
          this.$toast.fire({
            icon: "success",
            title: "Record has been successfully updated.",
          });
        })
        .catch((error) => {
          this.isLoadingBtn = false;
          this.formerror = error.response.data.errors;
          this.$toast.fire({ icon: "error", title: "Something went wrong!" });
        });
    },
    async deleteData(id) {
      this.isLoadingBtnDelete = true;
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to delete all record?"
        )
      ) {
        this.form
          .delete(this.$_CONFIG.api("API_FEATURED_NUMBER") + "/" + this.form.id)
          .then(() => {
            this.isLoadingBtnDelete = false;
            this.dialogForm = false;
            this.getDataFromApi();
            this.$toast.fire({
              icon: "success",
              title: "Record has been successfully deleted.",
            });
          })
          .catch(() => {
            this.isLoadingBtnDelete = false;
            this.$toast.fire({ icon: "error", title: "Something went wrong!" });
          });
      } else {
        this.isLoadingBtnDelete = false;
      }
    },
    paramsfilter() {
      var from,
        to = "";

      if (this.filter.daterange) {
        from = this.$moment(this.filter.daterange[0]).format("YYYY-MM-DD");
        to = this.$moment(this.filter.daterange[1]).format("YYYY-MM-DD");
      }

      return {
        ...this.dt_options,
        searchdata: this.dt_searchQuery,
        filterDateBlocFrom: from ? from : "",
        filterDateBlocTo: to ? to : "",
      };
    },
    async getDataFromApi() {
      this.dt_loading = true;
      var paramsfilter = await this.paramsfilter();
      this.dt_columns = await this.$YajraDT.setHeader(this.dt_headers);
      let params = await this.$YajraDT.params(
        paramsfilter,
        this.dt_options,
        this.dt_itemsPerPage,
        this.dt_columns
      );
      let apiPath = (await this.$_CONFIG.api()) + "/searchnumber";

      await this.$axios
        .post(apiPath + "?" + this.$.param(params))
        .then((res) => {
          if (this.dt_totalResult != res.data.recordsFiltered) {
            this.dt_options.page = 1;
          }

          this.dt_resultlist = res.data.data;
          this.dt_totalResult = res.data.recordsFiltered;
          this.dt_loading = false;
        })
        .catch((err) => {
          this.dt_loading = false;
          console.log(err);
        });

      var unwatch = this.$watch(
        "dt_options.page",
        function(newValue, oldValue) {
          this.getDataFromApi();
          unwatch();
        },
        { deep: true }
      );
    },
    async drawlist() {
      let response = await this.$axios.get(this.$_CONFIG.api() + "/draw/list");
      this.draw_list = response.data;
    },
  },
  created() {
    this.getDataFromApi();
  },
  mounted() {
    this.drawlist();
  },
};
</script>
<style scoped></style>